export const DEFAULT_SECTIONS_COUNT_TO_LOAD_ON_SSR = {
    START_RANGE: 0,
    END_RANGE: 10,
};
export const SECTIONS_TO_LOAD_ON_USER_INTERACTION = {
    START_RANGE: DEFAULT_SECTIONS_COUNT_TO_LOAD_ON_SSR.END_RANGE,
};

export const MULTIPLE_BG_IMG_KEYS_MAP = {
    section1bg: "section1-bg",
    section2bg: "section2-bg",
    section3bg: "section3-bg",
    section4bg: "section4-bg",
    section5bg: "section5-bg",
    section6bg: "section6-bg",
    section7bg: "section7-bg",
    section8bg: "section8-bg",
    section9bg: "section9-bg",
};

export const TEMPLATE_NAME = {
    template5: "template5",
    template6: "template6",
    template11: "template11",
    template9: "template9",
};

// sections range to load on SSR
export const TEMPLATE_SECTIONS_COUNT_TO_LOAD_ON_SSR = {
    [TEMPLATE_NAME.template6]: { START_RANGE: 0, END_RANGE: 10 },
};
